import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('BannerA');

    return (
        <div className={styles.BannerA}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1766051498272-u05u7e-compressed-Head-pc.jpg"
                pad="https://websiteoss.ecoflow.com/figma-uploads/1766051601280-kq21xf-compressed-head-mob.jpg"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1766051601280-kq21xf-compressed-head-mob.jpg"
            />
            <div className="title">{t('title')}</div>
        </div>
    );
}
